import { Category, ConcernName, Sensitivity, SkinType } from "../../type";
import type { ProductBaseIdRequest } from "../elc/elcProducts";
import * as actionTypes from "../../constantes/actionTypes"

export const getProductsId = async (market: string, concern: ConcernName, concernScore: number, skintype: SkinType, sensitivity: Sensitivity, dispatch: Function): Promise<{
    mainProducts: ProductBaseIdRequest[],
    otherProducts: ProductBaseIdRequest[],
    uvProducts: ProductBaseIdRequest[]
}> => {

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic Y3Jfb25saW5lOjJrV2RzM09yV3NTU1NEcG1KV2U3QVlhMWk4T3BwQ3pQbDg3NG8xWWdheTVZSVRGb0RkRUsybFBXdUZHSw==");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "_blueocean-cms_session=b562397112880866237515cf839fc90b");

    let dbMarket = getDBMarket(market)

    let raw = JSON.stringify({
        "market": dbMarket,
        "is_pretty_perfect": 0,
        "scores": {
            [concern]: concernScore
        },
        "questions": {
            "concern": concern,
            "skintype": skintype,
            "sensitivity-response": getSensitivityResponse(sensitivity)
        }
    })

    let productsObjectIds = await fetch("https://cms-prod.cliniquecomputer.com/cr/api/v1/recommendation", {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    })
        .then(response => response.json())
        .then(result => {
            dispatch({ type: actionTypes.UPDATE_MINDSTIX_RECO, value: result })
            let _otherProducts: ProductBaseIdRequest[] = []
            let _mainProducts: ProductBaseIdRequest[] = []
            let _uvProducts: ProductBaseIdRequest[] = []

            for (let category in result) {
                if (Array.isArray(result[category])) {
                    result[category].forEach((product: any, order: number) => {
                        const normalizeId = (id: unknown): string => id == null ? "" : String(id).trim();
                        const productRequest: ProductBaseIdRequest = {
                            prodBaseId: normalizeId(product.base) || normalizeId(product.base_id),
                            baseId: normalizeId(product.base_id),
                            productId: normalizeId(product.product_id),
                            skuID: normalizeId(product.sku),
                            instoreSku: normalizeId(product.instore_sku),
                            category: category as Category,
                            priority: order,
                        };
                        // Keep SPF recommendations even when the CMS base is absent or swapped.
                        if (category.includes("dailySpfProtectionQuiz")) {
                            _uvProducts.push(productRequest);
                        } else if (productRequest.prodBaseId) {
                            if (category === "id" || category === "serum") {
                                _mainProducts.push(productRequest);
                            } else if ((concern === "lines_wrinkles" || concern === "loss_of_volume") && category === "eyecream") {
                                _mainProducts.push(productRequest);
                            } else if ((concern === "pores_uneven_structure" || concern === "irritation") && category === Category.cream) {
                                _mainProducts.push(productRequest);
                            } else {
                                _otherProducts.push(productRequest);
                            }
                        } else {
                            _otherProducts.push(category === Category.bodyCare
                                ? { ...productRequest, prodBaseId: "6089" }
                                : productRequest);
                        }
                    })
                }
            }
            return { mainProducts: _mainProducts, otherProducts: _otherProducts, uvProducts: _uvProducts }
        })

        .catch(error => {
            console.log('error', error)
            return { mainProducts: [], otherProducts: [], uvProducts: [] }
        })

    return productsObjectIds
}

const getSensitivityResponse = (sensitivity: Sensitivity): string => {
    switch (sensitivity) {
        case Sensitivity.never:
            return "1"
        case Sensitivity.rarely:
            return "2"
        case Sensitivity.sometimes:
            return "3"
        case Sensitivity.often:
            return "4"
        case Sensitivity.constantly:
            return "5"
    }
}

const getDBMarket = (market: string): string => {

    switch (market) {
        case "CN":
            return "TRASIA"
        case "EMEA": // Europe -> Fr
            return "FR"
        case "EAEU":
            return "RU"
        case "UK": // England
            return "GB"
        case "LATAM": // South America (latin) -> Brazil
            return "BR"
        case "ASIA":
            return "CN"
        case "PAC": // APAC -> Australia
            return "AU"
        case "ES":
        case "SP":
            return "ES"
        case 'NA':
            return 'US'
        default:
            return market
    }
}
